import { formatShortCOP, QUOTE_MAX_GUESTS, QUOTE_MIN_GUESTS } from '@casa-aragon/utils';

import { usePublicPlanPrices } from '@/hooks/usePublicPlanPrices';
import { useLandingPriceEnabled } from '@/lib/clientPortalFlag';

// 31–50 is the most common guest bucket; the weekday plan gives the lowest honest "desde"
export const ANCHOR_GUESTS = 50;

/**
 * Under the hero copy: the guest range plus the weekday price for 50 guests, read from the live catalog. Two lines on
 * phones, one from md up. The block keeps a fixed height, so the price arriving never moves the CTA, and no figure is
 * shown until it is known. The price is behind `landing_price_enabled` (env default, Mantenimiento override): off, only the
 * guest range shows and the prices are never fetched.
 */
export function LandingPriceAnchor() {
  const priceEnabled = useLandingPriceEnabled();
  const { data, isLoading } = usePublicPlanPrices(priceEnabled ? ANCHOR_GUESTS : undefined);
  const weekday = data?.weekday ?? null;

  return (
    <p
      data-testid="landing-price-anchor"
      className="mt-3 h-10 md:h-5 flex flex-col md:flex-row items-center md:items-baseline justify-center md:justify-start md:gap-1.5 text-xs md:text-sm leading-5 text-white/90 drop-shadow-[0_1px_4px_rgba(0,0,0,0.5)]"
    >
      <span>
        Bodas de {QUOTE_MIN_GUESTS} a {QUOTE_MAX_GUESTS} invitados
      </span>
      {isLoading ? (
        <span aria-hidden="true" className="my-[3px] inline-block h-3.5 w-48 rounded bg-white/20 animate-pulse" />
      ) : (
        weekday !== null && (
          <span>
            <span className="hidden md:inline">· </span>Entre semana, {ANCHOR_GUESTS} invitados, desde{' '}
            <span className="font-medium text-white ca-num">{formatShortCOP(weekday)}</span>
          </span>
        )
      )}
    </p>
  );
}
